import React from "react";
import { Form, Button } from "react-bootstrap";
import SearchBar from "./SearchBar";
import styles from "./TableHeader.module.css";

interface TableHeaderProps {
  globalFilterValue: string;
  onGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  columns: { key: string; label: string }[];
  onSort: (key: string) => void;
  sortConfig: { key: string | null; direction: string | null };
  renderSortIcon: (key: string) => JSX.Element;
  itemsPerPage: number;
  onItemsPerPageChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ globalFilterValue, onGlobalFilterChange, columns, onSort, sortConfig, renderSortIcon, itemsPerPage, onItemsPerPageChange}) => (
  <div className="d-flex justify-content-between align-items-center mt-3">
    <SearchBar value={globalFilterValue} onChange={onGlobalFilterChange} />
    <div className={`d-flex justify-content-between align-items-center`}>
      <div className={styles.registerControlsText}>Mostrar</div>
      <Form.Select value={itemsPerPage} onChange={onItemsPerPageChange} className="w-auto">
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
      </Form.Select>
      <div className={styles.registerControlsText}>registros.</div>
    </div>
  </div>
);

export default TableHeader;
